// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
// import { getAnalytics } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB6BYQrnAOc-YC3_LYxnB41jDTzOnSECIg",
  authDomain: "august-cascade-362707.firebaseapp.com",
  projectId: "august-cascade-362707",
  storageBucket: "august-cascade-362707.appspot.com",
  messagingSenderId: "442595704621",
  appId: "1:442595704621:web:aa32800bf2a5b12cc91da4",
  measurementId: "G-QTJ3TQVD84",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
console.log('✅ Firebase App 初始化完成')



// Initialize Firebase Auth
const auth = getAuth(app)
console.log('✅ Firebase Auth 初始化完成')



// Initialize Firestore
const db = getFirestore(app)




export { auth }
export { db }
export default app
